import { render, staticRenderFns } from "./CompanionAppBanner.vue?vue&type=template&id=1d20d633&scoped=true"
import script from "./CompanionAppBanner.vue?vue&type=script&lang=ts"
export * from "./CompanionAppBanner.vue?vue&type=script&lang=ts"
import style0 from "./CompanionAppBanner.vue?vue&type=style&index=0&id=1d20d633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20d633",
  null
  
)

export default component.exports